import {FormError, FormValues} from '@wix/form-viewer'
import {FormViewer, FormViewerContext, FormViewerHandle} from '@wix/form-viewer/widget'
import {useBi, useTranslation} from '@wix/yoshi-flow-editor'
import React, {useRef, useState} from 'react'
import {useAppProps, useAppSelector} from '../../hooks/runtime'
import {getFormId} from '../../selectors/event'

export const WixForm = () => {
  const appProps = useAppProps()
  const bi = useBi()
  const {i18n} = useTranslation()
  const formId = useAppSelector(getFormId)

  const formViewer = useRef<FormViewerHandle>(null)
  const [formValues, setFormValues] = useState<FormValues>({})
  const [formErrors, setFormErrors] = useState<FormError[]>([])

  return (
    <FormViewerContext {...appProps}>
      <FormViewer
        i18n={i18n}
        bi={bi}
        ref={formViewer}
        values={formValues}
        errors={formErrors}
        onValidate={setFormErrors}
        onChange={setFormValues}
        formId={formId}
      />
    </FormViewerContext>
  )
}
